export function getOrCreateGuestId() {
  let guestId = localStorage.getItem("guest_id");

  if (!guestId) {
    const browserCrypto = window.crypto;
    if (!browserCrypto?.randomUUID) {
      throw new Error("Canonical guest identity generator is unavailable");
    }

    guestId = browserCrypto.randomUUID();
    localStorage.setItem("guest_id", guestId);
  }

  return guestId;
}

export function clearGuestId() {
  localStorage.removeItem("guest_id");
}
